<template>
  <div class="lorderApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="order-tab">
      <span @click="toggle(3)" :class="{curt:3==active}">待接单</span>
      <span @click="toggle(4)" :class="{curt:4==active}">配送中</span>
      <span @click="toggle(5)" :class="{curt:5==active}">已送达</span>
    </div>
    <div style="height:60px"></div>

    <div class="pro" v-for="(item,i) in order" v-if="order.length >0">
      <div class="bussTitle">
        <el-image style="width:50px;height:50px; border-radius:50%;float:left" :src="baseUrl+item.logo" fit="cover"></el-image>
        <div class="name">
          <p>{{item.startTitle}}</p>
          <p>编号：{{item.number}}</p>
        </div>
        <div class="status" :style="item.status == 3 ? 'background: #FEF3E6;color:#ED7B2F' : item.status == 4 ? 'background: #FDECEE;color: #E34D59;' : item.status == 5 ? 'background: #EFEDF7;color: #5326DB;' : item.status == 6 ? 'background: #E8F8F2;color: #00A870;' : ''">{{item.status == 2 ? '已支付\n未存放' : item.status == 3 ? '已存放\n待配送' : item.status == 4 ? '配送中\n待入库' : item.status == 5 ? '已入库\n待领取' : '已完成'}}</div>
      </div>
      <div class="goods">
        <div class="left">
          <el-image style="width:100%;height:50px; border-radius:5px;" :src="baseUrl+item.image" fit="cover"></el-image>
        </div>
        <div class="right">
          <p>{{item.title}}</p>
          <div class="num">{{item.num}}件</div>
          <div class="price">
            <i>￥</i><b>{{item.price.split(".")[0]}}</b>
            <i>.{{item.price.split(".")[1]}}</i>
          </div>
        </div>
      </div>
      <div class="email">
        支付时间
        <span>{{item.paytime}}</span>
      </div>
      <div class="email">
        送达地址
        <span>{{item.address}}</span>
      </div>
      <div class="email">
        送达时间
        <span>{{item.deliver_time}}</span>
      </div>
      <div class="email">
        备注
        <span>{{item.mark}}</span>
      </div>
      <div class="email" style="border-bottom:none">
        <a v-if="item.status >= 2"  @click="goCode(item.id)">{{item.status == 3 ? '去接单' : item.status == 4 ? '确认送达' : '配送详情'}}<font class="el-icon-arrow-right"></font></a>
        <span class="curt">总金额：￥{{item.price}}元</span>
      </div>
    </div>

    <div style="height:10px"></div>
    <div class="none" v-if="order.length <= 0">
      <img src="~assets/images/none.png">
      <p>暂无数据</p>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        userData:[],
        order:[],
        curHeight:0,
        fullscreenLoading: true,
        active:3,
        baseUrl:'',
        code:'',
      };
    },
    created(){
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/lhall');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }else{
        this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
        this.getOrder();
      }
    },

    methods: {
      toggle(index){
        this.active=index;
        this.getOrder();
      },
      goCode:function(id){
        window.location.href="http://user.4008005216.com/main/lcode?id="+id
      },
      setCode:function(id){
        this.$router.push({
          path:'pcode',
          query:{
            id:id
          }
        })
      },
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },  
      backTop:function(){
        const that = this;
        let ispeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
      },
      getOrder:function(){
        var that = this;
        that.fullscreenLoading = true
        $.ajax({
          type:'post',
          url:that.$host+'home/luggage/hall',
          data:{
            user_id:that.userData.id,
            state:that.active
          },
          dataType:'json',
          success:function(data){
            that.order = data.data;
            that.fullscreenLoading = false;
          }
        })
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
          that.userData = res.data;
          that.getOrder();
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .lorderApp{
    max-width:640px;
    background:#F1F2F5;
    margin:0 auto;
  }
  .lorderApp .order-tab{
    position:fixed;
    width:100%;
    height:50px;
    left:0;
    top:0;
    background:#fff;
    z-index:99
  }
  .lorderApp .order-tab span{
    float:left;
    width:16.5%;
    text-align:center;
    font-size:15px;
    position:relative;
    height:50px;
    line-height:50px;
  }
  .lorderApp .order-tab span font{
    position:absolute;
    width:14px;
    height:14px;
    background:#f00;
    border-radius: 50%;
    top:10px;
    right:0;
    color:#fff;
    font-weight:normal;
    line-height:16px;
    font-size:10px
  }
  .lorderApp .order-tab span.curt{
    color:#406DE1;
    font-weight:bold;
  }
  .lorderApp .order-tab span.curt:after{
    position:absolute;
    content:'';
    width:15px;
    height:2px;
    background:#406DE1;
    bottom:10px;
    left:50%;
    transform: translateX(-50%);
  }
  .lorderApp .order-item{
    width: 100%;
    display: block;
    background: #fff;
    margin: 0px auto 8px auto;
  }

  .lorderApp .pro{
    background:#fff;
    display:block;
    width:94%;
    border-radius: 6px;
    margin:0 auto 12px auto;
  }
  .lorderApp .pro .goods:after,.lorderApp .pro .bussTitle:after,.lorderApp .email:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .lorderApp .pro .bussTitle{
    width:92%;
    margin:0 auto;
    padding:15px 0 10px 0;
  }
  .lorderApp .pro .bussTitle img{
    width:50px;
    border-radius:5px;
    float:left;
  }
  .lorderApp .pro .bussTitle .name{
    float:left;
    width:68%;
    margin-left:2%
  }
  .lorderApp .pro .bussTitle .name p{
    font-size:15px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    font-weight:bold
  }
  .lorderApp .pro .bussTitle .name p:last-child{
    font-size:13px;
    padding-top:8px;
    color:#999;
    font-weight:normal
  }
  .lorderApp .pro .bussTitle .status{
    float:right;
    font-size:12px;
    color: #0052D9;
    margin-top:4px;
    white-space: pre-line;
    background: #ECF2FE;
    border-radius: 5px;
    padding:4px 8px
  }
  .lorderApp .goods{
    background:#f5f5f5;
    width:92%;
    margin:0 auto 1px auto;
  }
  .lorderApp .goods .left{
    float:left;
    width:16%;
    border-radius:5px;
    margin:4% 2% 2% 4%;
  }
  .lorderApp .goods .right{
    float:left;
    margin-top:4%;
    width:73%;
    position: relative;
  }
  .lorderApp .goods .right p{
    font-size:15px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    color:#000;
    width:78%
  }
  .lorderApp .goods .right .num{
    font-size: 13px;
    color: #999999;
    padding-top:12px;
  }
  .lorderApp .goods .right .price{
    color:#f00;
    font-size:15px;
    position: absolute;
    top:50%;
    transform: translateY(-50%);
    right:0;
    text-align:right
  }
  .lorderApp .goods .right .price div{
    font-size:12px;
    color:#999;
    text-decoration: line-through;
  }
  .lorderApp .goods .right .price b{
    color: #f00;
    font-size:16px;
    font-weight:600;
  }

  .lorderApp .goods .right .price i{
    color: #f00;
    font-size:13px;
    font-style:normal
  }
  
  .lorderApp .goods .right .price font{
    color:#666;
    font-size:14px;
    padding-left:8px
  }

  .lorderApp .email{
    background:#fff;
    height:50px;
    line-height:50px;
    font-size:15px;
    color:#333;
    display:block;
    padding-left:4%;
    margin:0 auto;
    font-size: 15px;
    border-bottom:solid 1px #f5f5f5;
  }
  .lorderApp .email span{
    color:#666;
    font-size: 15px;
    float:right;
    font-weight:normal;
    margin-right:4%
  }
  .lorderApp .email span.curt{
    color:#f00;
    border-radius:5px;
    font-size:16px;
  }
  .lorderApp .email a{
    float:right;
    color:rgba(0,74,224,.7);
    margin-right:4%;
    font-size:15px;
    padding-left:10px;
    font-weight:bold
  }

  .lorderApp .none{
    text-align:center;
    padding-top:50%;
  }
  .lorderApp .none img{
    width:120px;
  }
  .lorderApp .none p{
    color:#cdcdcd;
    font-size:14px;
  }

</style>